import { __assign, __extends } from "tslib";
import React from 'react';
import { expandCollapseManager } from '../../..';
var withCollapseExpand = function (WrappedComponent) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.handleChatExpand = function () {
                _this.setState({ isExpanded: true });
            };
            _this.handleChatCollapse = function () {
                _this.setState({ isExpanded: false });
            };
            _this.state = {
                isExpanded: false,
            };
            expandCollapseManager.registerOnCollapse(_this.handleChatCollapse);
            expandCollapseManager.registerOnExpand(_this.handleChatExpand);
            return _this;
        }
        class_1.prototype.componentWillUnmount = function () {
            expandCollapseManager.unregisterOnExpand(this.handleChatExpand);
            expandCollapseManager.unregisterOnCollapse(this.handleChatCollapse);
        };
        class_1.prototype.render = function () {
            var isExpanded = this.state.isExpanded;
            // `as P` can be removed once the following issue closes
            // https://github.com/Microsoft/TypeScript/issues/28884
            var injectedProps = __assign(__assign({}, this.props), { isExpanded: isExpanded });
            return React.createElement(WrappedComponent, __assign({}, injectedProps));
        };
        return class_1;
    }(React.Component));
};
export default withCollapseExpand;
//# sourceMappingURL=withCollapseExpand.js.map